export default {
  1: "var(--spacing-1)",
  2: "var(--spacing-2)",
  3: "var(--spacing-3)",
  4: "var(--spacing-4)",
  5: "var(--spacing-5)",
  6: "var(--spacing-6)",
  7: "var(--spacing-7)",
  8: "var(--spacing-8)",
  9: "var(--spacing-9)",
  "button-height-1": "var(--button-height-1)",
  "button-height-2": "var(--button-height-2)",
  "button-height-3": "var(--button-height-3)",
  "button-height-4": "var(--button-height-4)",
  "menu-item-height-2": "var(--menu-item-height-2)",
  "menu-item-height-1": "var(--menu-item-height-1)",
  "table-cell-min-height-1": "var(--table-cell-min-height-1)",
  "table-cell-min-height-2": "var(--table-cell-min-height-2)",
  "table-cell-min-height-3": "var(--table-cell-min-height-3)",
  "table-cell-padding-1": "var(--table-cell-padding-1)",
  "table-cell-padding-2": "var(--table-cell-padding-2)",
  "table-cell-padding-3": "var(--table-cell-padding-3)",
};
